import React, { useState } from 'react';
import Modal from '../../components/Modal';
import { FiTarget } from 'react-icons/fi';
import styles from '../../styles/testParamsModal.module.css';

const TestParameterModal = ({ isOpen, onClose, defaultCount = 10, defaultType = 'Mixed', onConfirm }) => {
  const [count, setCount] = useState(defaultCount);
  const [type, setType] = useState(defaultType);

  const clamp = (n) => {
    const num = Number(n) || 0;
    return Math.max(1, Math.min(50, num));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm?.({ count: clamp(count), type });
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Practice Test">
      <form className={styles.container} onSubmit={handleSubmit}>
        <div className={styles.headerRow}>
          <div className={styles.iconWrap}><FiTarget size={18} /></div>
          <div className={styles.headerText}>Choose your test parameters</div>
        </div>

        <div className={styles.fieldGroup}>
          <label className={styles.label} htmlFor="questionCount">Number of questions</label>
          <div className={styles.counterWrap}>
            <button type="button" className={styles.counterBtn} onClick={() => setCount((c) => clamp(c - 1))} aria-label="Decrease">-</button>
            <input
              id="questionCount"
              className={styles.countInput}
              type="number"
              min={1}
              max={50}
              value={count}
              onChange={(e) => setCount(e.target.value)}
            />
            <button type="button" className={styles.counterBtn} onClick={() => setCount((c) => clamp(c + 1))} aria-label="Increase">+</button>
          </div>
          <div className={styles.hint}>Up to 50 questions for best performance</div>
        </div>

        <div className={styles.fieldGroup}>
          <div className={styles.label}>Question type</div>
          <div className={styles.typeGrid}>
            {['Multiple Choice', 'Short Response', 'Fill in the Blank', 'Mixed'].map((t) => (
              <button
                type="button"
                key={t}
                onClick={() => setType(t)}
                className={`${styles.typePill} ${type === t ? styles.active : ''}`}
                aria-pressed={type === t}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className={styles.footerRow}>
          <button type="button" className={styles.secondary} onClick={onClose}>Cancel</button>
          <button type="submit" className={styles.primary}>Generate Test</button>
        </div>
      </form>
    </Modal>
  );
};

export default React.memo(TestParameterModal);
